class TopBarInfo {
  private elements: NodeListOf<HTMLElement>;

  constructor(elements: NodeListOf<HTMLElement>) {
    this.elements = elements;
    this.init();
  }

  private init(): void {
    this.getUserInfo();
  }

  private getFrontendLogger(): { logError?: (payload: unknown) => void } | undefined {
    const vgrWindow = window as {
      VgrFrontend?: {
        logger?: { logError?: (payload: unknown) => void };
      };
    };

    return vgrWindow.VgrFrontend && vgrWindow.VgrFrontend.logger;
  }

  private getUserInfo(): void {
    const pageId = this.getMeta('SidID');
    const requestUrl = `/accountinfo/getsession?pageid=${encodeURIComponent(pageId)}`;

    fetch(requestUrl, {
      method: 'GET',
    })
      .then((response) => {
        if (!response.ok) {
          this.handleNonOkResponse(response, requestUrl, pageId);
          return null;
        }

        return response.json();
      })
      .then((data) => {
        if (!data) {
          return;
        }

        if (data.auth) {
          this.updateUserInfo(data);
        }
      })
      .catch((error) => this.handleUnexpectedError(error, requestUrl, pageId));
  }

  private updateUserInfo(data: any): void {
    const body = document.body;

    if (body.dataset.pagetype === 'StartPage') {
      this.updateWelcomeHeading(data);
    }

    this.updateContactForm(data);
    this.updateElements(data);
  }

  private updateWelcomeHeading(data: any): void {
    const welcomeHeading = document.getElementById('h1id');
    if (welcomeHeading) {
      welcomeHeading.textContent = `${data.lang} ${data.firstname}`;
    }
  }

  private updateContactForm(data: any): void {
    const contactForm = document.getElementById('page-footer-contact-form');
    if (contactForm) {
      this.setInputValue('contact-form-name', data.name);
      this.setInputValue('contact-form-phone', data.telephonenr);
      this.setInputValue('contact-form-email', data.mail);
    }
  }

  private setInputValue(id: string, value: string | undefined): void {
    const field = document.getElementById(id) as HTMLInputElement | null;
    if (field && value) {
      field.value = value;
    }
  }

  private updateElements(data: any): void {
    this.elements.forEach((element) => {
      const links = element.querySelectorAll('.intra-header-content__links');
      const notLoggedInfo = element.querySelectorAll('.intra-header-content__notLoggedInfo');
      const personLinks = element.querySelectorAll('.intra-header-content__personlink');
      const personSpans = element.querySelectorAll('.intra-header-content__personlink span');
      const profileImages = element.querySelectorAll('.intra-header-content__profileimage');
      const imageLinks = element.querySelectorAll('.intra-header-content__img');

      // Remove/Set display styles for logged-in status
      links.forEach((link) => link.removeAttribute('style'));
      notLoggedInfo.forEach((info) => info.setAttribute('style', 'display: none'));

      // Update person-related info
      if (data.link) {
        personLinks.forEach((link) => link.setAttribute('href', data.link));
      }

      if (data.name) {
        personSpans.forEach((span) => (span.textContent = data.name));
      }

      if (data.photo) {
        profileImages.forEach((img) => {
          img.setAttribute('src', data.photo);
          img.setAttribute('aria-label', 'Länk till din profil i Delve');
        });
        imageLinks.forEach((link) => link.setAttribute('href', data.link));
      }
    });
  }

  private handleNonOkResponse(response: Response, requestUrl: string, pageId: string): void {
    const frontendLogger = this.getFrontendLogger();
    if (frontendLogger && typeof frontendLogger.logError === 'function') {
      frontendLogger.logError({
        category: 'top-personalization',
        eventName: 'session-request-non-ok-response',
        componentOrWidget: 'TopBarInfo',
        url: requestUrl,
        data: {
          pageId,
          status: response.status,
          url: requestUrl,
        },
      });
    }

    console.error('Error fetching user info:', {
      status: response.status,
      url: requestUrl,
      pageId,
    });
    alert('Could not load user information. Please try again later.');
  }

  private handleUnexpectedError(error: any, requestUrl: string, pageId: string): void {
    const frontendLogger = this.getFrontendLogger();
    if (frontendLogger && typeof frontendLogger.logError === 'function') {
      frontendLogger.logError({
        category: 'top-personalization',
        eventName: 'session-request-failed',
        componentOrWidget: 'TopBarInfo',
        url: requestUrl,
        data: {
          pageId,
          status: error && error.status,
          url: requestUrl,
          name: error && error.name,
          message: error && error.message,
        },
      });
    }

    console.error('Error fetching user info:', error);
    alert('Could not load user information. Please try again later.');
  }

  private getMeta(metaName: string): string {
    const meta = document.querySelector(`meta[name="${metaName}"]`) as HTMLMetaElement | null;
    return meta ? meta.getAttribute('content') || '' : '';
  }
}

// Användning
const topBarElements = document.querySelectorAll('.intra-header-content__person-wrapper') as NodeListOf<HTMLElement>;
if (topBarElements.length) {
  new TopBarInfo(topBarElements);
}
